<header>
  <h1 mat-dialog-title>AI Assist Config</h1>
  <aside>
    <mat-icon fontIcon="close" matTooltip="Close" matTooltipShowDelay="500" (click)="onCancel()"></mat-icon>
  </aside>
</header>
<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [dynamicHeight]="true" animationDuration="750ms"
  preserveContent>
  <mat-tab label="Configuration">
    <div mat-dialog-content class="tab-content">
      <h2 class="heading-underline"><mat-icon fontIcon="emoji_events"></mat-icon> Apply options across your prompt profiles</h2>
      <table class="full-width table-striped table-td-border-right">
        <tr>
          <td>
            @if (promptOptions.role) {
              <app-options-autocomplete
                [(chosenOptions)]="promptOptions.role"
                [title]="'Roles'"
                [icon]="'person'"
              [suggestedOptions]="SUGGESTED_ROLES"></app-options-autocomplete>
            }
          </td>
          <td>
            @if (promptOptions.tone) {
              <app-options-autocomplete
                [(chosenOptions)]="promptOptions.tone"
                [title]="'Tones'"
                [icon]="'interpreter_mode'"
              [suggestedOptions]="SUGGESTED_TONES"></app-options-autocomplete>
            }
          </td>
          <td>
            @if (promptOptions.format) {
              <app-options-autocomplete
                [(chosenOptions)]="promptOptions.format"
                [title]="'Formats'"
                [icon]="'description'"
              [suggestedOptions]="SUGGESTED_FORMATS"></app-options-autocomplete>
            }
          </td>
        </tr>
        <tr>
          <td>
            @if (promptOptions.resultLength) {
              <app-options-autocomplete
                [(chosenOptions)]="promptOptions.resultLength"
                [title]="'Result lengths'"
                [icon]="'square_foot'"
              [suggestedOptions]="SUGGESTED_RESULT_LENGTHS"></app-options-autocomplete>
            }
          </td>
          <td>
            @if (promptOptions.explanationDifficulty) {
              <app-options-autocomplete
                [(chosenOptions)]="promptOptions.explanationDifficulty"
                [title]="'Explanation difficulties'"
                [icon]="'landscape'"
              [suggestedOptions]="SUGGESTED_EXPLANATION_DIFFICULTIES"></app-options-autocomplete>
            }
          </td>
          <td>
            @if (promptOptions.outputLanguage) {
              <app-options-autocomplete
                [(chosenOptions)]="promptOptions.outputLanguage"
                [title]="'Languages'"
                [icon]="'language'"
              [suggestedOptions]="SUGGESTED_LANGUAGES"></app-options-autocomplete>
            }
          </td>
        </tr>
      </table>
    </div>
  </mat-tab>

  <mat-tab label="Template">
    <div mat-dialog-content class="tab-content template-config">
      <input
        class="hidden-upload-button"
        type="file"
        accept=".docx"
        (change)="queueFileUpload($event.target)"
        (click)="fileUpload.value = ''"
        #fileUpload
        />
        <h2 class="heading-underline docx-header">
          Upload .docx template
          <span class="warning-message">
            <mat-icon fontIcon="error_outlined"></mat-icon>
            Max file upload of {{ MAX_FILE_SIZE_MB }} MB
          </span>
        </h2>
        <span class="docx-info">
          A blank Word document used for styling the final output document. Headers and footers are retained, but all other content is replaced.
        </span>
      @if (promptProfileMeta.baseHtmlStyleFile?.name) {
        <ul>
          <li>
            <span class="file-type docx docx-icons"><span>docx</span></span>
            <span class="file-name">{{promptProfileMeta.baseHtmlStyleFile?.name}}</span>
            <span class="action-icons">
        <mat-icon
          fontIcon="file_download"
          class="download material-icons-outlined"
          (click)="downloadFile()"
          matTooltip="Download file"
          matTooltipShowDelay="500"
        ></mat-icon>
      </span>
          </li>
        </ul>
      }
      <button class="upload-btn" (click)="fileUpload.click()" appRipple>
          UPLOAD FILE
          <mat-icon fontIcon="file_upload" class="upload-icon material-icons-outlined"></mat-icon>
        </button>
      </div>
    </mat-tab>
  </mat-tab-group>
  <section mat-dialog-actions class="footer-btns">
    <button class="danger-btn-hover" (click)="onCancel()" tabindex="0">cancel</button>
    <button type="submit" (click)="onSave()" [disabled]="!form.valid" tabindex="0">save</button>
  </section>
